import * as React from 'react'
import ReactHtmlParser from 'react-html-parser'
import { useTranslation } from 'react-i18next'
import { Outlet } from 'react-router-dom'
import { BackgroundImage, Stack, Title } from '@mantine/core'
import homepage from '@/assets/images/booking/homepageOriginal.png'
import { useAppState } from '@/features/app/hooks'
import { SectionPartners } from '@/features/auth/components/SectionPartners'
import { useHeaderContext } from '@/features/header/contexts/HeaderContext'
import { ROLE } from '@/features/user/types'
import useStyles from './AuthLayout.styles'

interface IProps {
  role?: ROLE
}

export const AuthLayout = ({ role }: IProps) => {
  const { classes } = useStyles()
  const { t } = useTranslation()
  const {
    appState: { mobileView },
  } = useAppState()

  const { setKey } = useHeaderContext()

  React.useEffect(() => {
    setKey({ base: true, title: 'auth', border: true })
  }, [])

  return (
    <>
      {/*mobileView && (*/}
      <Stack className={classes.background}>
        <div className={classes.section}>
          <div id="contentBooking" className={classes.contentSection}>
            <Stack className={classes.stackPosition}>
              <BackgroundImage src={homepage} radius="sm">
                <div className={classes.backgroundHomepage} />
                <div className={classes.textOnImage}>
                  <div className={classes.textHomepage}>
                    <Title order={mobileView ? 3 : 1}>
                      {ReactHtmlParser(t('book.image_message'))}
                    </Title>
                  </div>
                </div>
              </BackgroundImage>

              <div className={classes.partnersSection}>
                <SectionPartners />
              </div>

              <Outlet />
            </Stack>
          </div>
        </div>
      </Stack>
      {/*})}
      {!mobileView && (
        <div className={classes.wrap}>
          <div className={classes.contentSection}>
            <ContentSection />
          </div>
          {!mobileView && (
            <div className={classes.infoSection}>
              <InfoSection role={role} />
            </div>
          )}
        </div>
      )*/}
    </>
  )
}
